/*
 * @Author: Teemo Ding
 * @Date: 2022-05-11 14:17:19
 * @LastEditTime: 2022-06-07 11:23:13
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/Components/TransferOwnershipModal/index.tsx
 */
import { ModalFooter, Select } from '@/src/components/Antd';
import PasswordInput from '@/src/components/Password';
import {
  getUserList,
  transferOwnership,
} from '@/src/request/settings/permission';
import { useLocalStorageState, useRequest } from 'ahooks';
import { Form, message, Spin } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { ACCOUNT_INFO as _ACCOUNT_INFO } from 'src/tools/config';
import { generateKey } from 'src/tools/getUserInfo';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from './css.module.less';

const TransferOwnershipModal = ({ onCancel, onUpdate }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const k = generateKey(_ACCOUNT_INFO);
  const [accountInfo] = useLocalStorageState<any>(k, {
    storeUuid: '',
  });
  const { data: userList = [], loading } = useRequest(() =>
    getUserList(accountInfo.storeUuid),
  );
  const { run: _transferOwnership, loading: transferOwnershipLoading } =
    useRequest((data) => transferOwnership(data), {
      manual: true,
      onSuccess: () => {
        message.success(getI18n('general.deletedsuccessfully'));
        onUpdate();
      },
    });

  const options = userList.map((item, index) => ({
    label: (
      <div key={index}>
        <div className={css.selectItemTitle}>{item.fullName || ''}</div>
        <span className={css.selectItemIntroduce}>
          {get(item, 'email', '') || `+${get(item, 'mobile', '')}`}
        </span>
      </div>
    ),
    value: get(item, 'uuid', ''),
  }));

  const onFinish = (values) => {
    const { password, toUserUuid } = values;
    _transferOwnership({
      password,
      toUserUuid,
      storeUuid: accountInfo.storeUuid,
    });
  };

  return (
    <Spin spinning={loading}>
      <Form
        className={css.transferOwnershipModal}
        form={form}
        onFinish={onFinish}
        name='transferOwnershipModal'>
        <div className={css.p}>
          {getI18n('usersAndPermissions.detail.transferOwnershipModalTip')}
        </div>
        <Form.Item
          name='password'
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('usersAndPermissions.detail.password'),
              ),
            },
          ]}
          label={getI18n('usersAndPermissions.detail.password')}
          labelCol={{ span: 24 }}>
          <PasswordInput editable={true} />
        </Form.Item>
        <Form.Item
          name='toUserUuid'
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('usersAndPermissions.detail.newStoreOwner'),
              ),
            },
          ]}
          label={getI18n('usersAndPermissions.detail.newStoreOwner')}
          labelCol={{ span: 24 }}>
          <Select options={options} size='large' />
        </Form.Item>
      </Form>
      <ModalFooter
        danger
        okText={getI18n('usersAndPermissions.detail.transferOwnership')}
        onOk={() => form.submit()}
        onCancel={onCancel}
        loading={transferOwnershipLoading}
      />
    </Spin>
  );
};

export default TransferOwnershipModal;
